import { makeAutoObservable } from 'mobx';

class CompanyDocumentViewModel {
  uiState;
  companyDocument;
  selected = false;

  constructor(companyDocument, uiState) {
    makeAutoObservable(this);

    this.companyDocument = companyDocument;
    this.uiState = uiState;

    this.selected = !!companyDocument.draftEmployeeId;
  }
}

export default CompanyDocumentViewModel;
